import React from "react";
import MDBox from "../../materialDashboard/components/MDBox";


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <MDBox sx={{ mt: 3}}>
                    {children}
                </MDBox>
            )}
        </div>
    );
}

export default TabPanel;